const riot = require('riot');

riot.tag2('module-note-filter', '<div class="f fm overflow-scroll scrollbar-none"> <div class="flex-fixed max-width-330 w50vw mr24"> <form class="w-full relative" onsubmit="{onUpdateQuery}"> <input class="input pale w-full py5 pr30 fs13" type="search" ref="query" placeholder="タグ、キーワードで絞り込み" oninput="{debouncedUpdateQuery}" onkeydown="{onKeydown}"><i class="icon-close absolute t0 b0 r24 f fh h-full p6 fs16 cursor-pointer" onclick="{onDeleteQuery}" if="{refs.query.value}"></i><i class="icon-arrow-down absolute t0 b0 r0 f fh h-full p6 fs16 cursor-pointer" onclick="{onOpenSuggestions}"></i> </form> </div> <div class="flex-fixed f fm mr8" if="{opts.enableProject}"> <button class="f fm bg-background_light_primary hover-trigger hover-bg-pale hover-text-label_dark_primary rounded-4 p4 fs12" onclick="{onClickProject}"> <div class="line-clamp-1 word-break-all word-keep-all lh15 mr2">{project ? project.data.name : ⁗全てのプロジェクト⁗}</div><i class="icon-arrow-down fs10 text-label_dark_medium pt6 pb4 px4"></i> </button> </div> <div class="flex-fixed f fm mr8" if="{opts.customFilters}"> <div class="tooltip flex-fixed f fm cursor-pointer mr12" each="{item in opts.customFilters}" aria-label="{item.tooltip}" data-tooltip-position="top"> <input class="flex-fixed checkbox" ref="checkboxes" name="{item.id}" type="checkbox" onclick="{onClickCustomCheckbox}" checked="{parent.query.options[item.id]}"> <div class="cursor-pointer f fm flex-fixed ml4" onclick="{onClickCustomFilter}"> <div class="lh15 fs12 flex-fixed hover-trigger hover-text-primary {isEnabledCustomFilter(item) ? &quot;text-primary bold&quot; : &quot;text-label_dark_medium&quot;}">{item.label}</div> <div class="f fh s16 flex-fixed hover-trigger hover-text-primary" if="{item.actionArrowDown}" onclick="{onClickCustomFilterArrowDown}"><i class="icon-arrow-down fs10 text-label_dark_medium pt6 pb4 px4"></i></div> </div> </div> </div> <div class="flex-fixed f fm mr8"> <label class="flex-fixed f fm cursor-pointer mr16" each="{item in opts.statusFilters || statusFilters}"> <input class="checkbox mr4" ref="checkboxes" name="{item.id}" type="checkbox" onchange="{onClickCheckboxFilter}" checked="{parent.query.options[item.id] === true}"> <div class="lh15 fs12 hover-trigger hover-text-primary {parent.query.options[item.id] ? &quot;text-primary bold&quot; :  &quot;text-label_dark_medium&quot;}">{item.label}</div> </label> </div> <div class="flex-fixed f fm mr8"> <label class="flex-fixed f fm cursor-pointer mr12" each="{item in userFilters}" if="{opts.users}"> <input class="checkbox" ref="checkboxes" name="{item.id}" type="checkbox" onclick="{onClickUsersFilter}" checked="{parent.query.options[item.id]}"> <div class="lh15 fs12 hover-trigger hover-text-primary ml4 {isEnabledUserFilter(item) ? &quot;text-primary bold&quot; : &quot;text-label_dark_medium&quot;}">{item.label}</div> <div class="f fh s16 hover-trigger hover-text-primary cursor-pointer tooltip" onclick="{onOpenPopupSuggestionUsers}" aria-label="ユーザーで絞り込み"><i class="icon-arrow-down fs10 text-label_dark_medium pt6 pb4 px4"></i></div> </label> </div> </div>', 'module-note-filter,[data-is="module-note-filter"]{display:block} module-note-filter input.input:focus,[data-is="module-note-filter"] input.input:focus{border:1px solid rgba(29,40,76,0.1) !important} module-note-filter input:focus::placeholder,[data-is="module-note-filter"] input:focus::placeholder{color:rgba(29,40,76,0.46)}', '', function(opts) {
    this.statusFilters = [
      {id: 'mention', label: 'メンション'},
      {id: 'unread', label: '未読'},
      {id: 'favorite', label: 'お気に入り'},
      {id: 'period', label: '期限あり'},
      {id: 'unassigned', label: '未アサイン', toggle: ['assigned']},
      {id: 'updatedToday', label: '本日更新'},
      {id: 'parent', label: '親タスク' },
    ];

    if (this.opts.enableClosed) {
      this.statusFilters.push({id: 'closed', label: 'クローズも含む'});
    }

    this.userFilters = [
      {id: 'assigned', label: 'アサイン', toggle: ['unassigned']},
      {id: 'created', label: '作成者'},
      {id: 'updated', label: '更新者'},
    ];

    this.on('mount', () => {
      if (spat.isNode) return ;
      this.updateQuery();
    });

    this.updateQuery = () => {
      this.query = QuerySearch.parse(this.refs.query.value);

      this.userFilters.forEach(userFilter => {
        let screen_name = this.query.options[userFilter.id];

        if (screen_name) {
          let user = this.opts.users.find(user => user.data.screen_name === screen_name);

          if (user) {

            this.query.options[userFilter.id + '_id'] = user.id;
          }
          else {

            this.query.options[userFilter.id + '_id'] = '-';
          }
        }
      });

      if (this.opts.columns) {
        if (this.query.options.column) {
          let column = this.opts.columns.find(c => c.data.name === this.query.options.column);
          if (column) {
            this.query.options['column_id'] = column.id;
          }
        }
      }

      this.update();

      this.trigger('filterchange', { q: this.getQueryValue() });
    };

    this.onUpdateQuery = (e) => {
      e && e.preventDefault();
      this.updateQuery();
    };

    this.debouncedUpdateQuery = _.debounce(() => {
      this.updateQuery();
    }, 128);

    this.onDeleteQuery = () => {
      this.setQueryValue('');
    };

    this.onClickCheckboxFilter = (e) => {
      let query_value = `${e.item.item.id}:true`;
      this.toggleQueryValue(query_value, e.item.item.toggle);
    };

    this.onClickUsersFilter = (e) => {

      let screen_name = this.query.options[e.item.item.id] || app.store.currentUser.data.screen_name;
      this.toggleQueryValue(`${e.item.item.id}:${screen_name}`, e.item.item.toggle);
    };

    this.setQueryValue = (value) => {

      if (value) value += ' ';

      this.refs.query.value = value;

      this.debouncedUpdateQuery();

      if (app.useragent.isDesktop) {
        this.focus();
      }
    };

    this.addQueryValue = (value) => {
      let query = this.refs.query;
      let new_value = query.value;
      new_value = new_value.trim() + ` ${value} `;
      new_value = new_value.trim();

      this.setQueryValue(new_value);
    };

    this.removeQueryValue = (value) => {
      let query = this.refs.query;
      let new_value = query.value;

      new_value = new_value.replace(value, '');

      new_value = new_value.replace(/(\s)+/g, ' ');

      new_value = new_value.trim();

      this.setQueryValue(new_value);
    };

    this.toggleQueryValue = (value, toggle = []) => {
      if (this.refs.query.value.indexOf(value) === -1) {
        [].concat(toggle || []).forEach(id => {
          this.removeQueryParam(id);
        });
        this.addQueryValue(value);
      }
      else {
        this.removeQueryValue(value);
      }
    };

    this.getQueryParam = (id) => {
      return this.query.options[id];
    };

    this.setQueryParam = (id, value, toggle) => {
      this.removeQueryParam(id);
      if (value) {
        [].concat(toggle || []).forEach(id => {
          this.removeQueryParam(id);
        });
        this.addQueryValue(`${id}:${value}`);
      }
      else {
        this.updateQuery();
      }
    };

    this.removeQueryParam = (id) => {

      const regexp = new RegExp(`(^|\\s)${app.utils.regexp.escape(id)}:\\S+`, 'g');
      this.refs.query.value = this.refs.query.value.replace(regexp, '');
    };

    this.getQuery = () => {
      return this.query;
    };

    this.getQueryValue = () => {
      return this.refs.query.value;
    };

    this.onOpenPopupSuggestionUsers = async (e) => {
      e.preventDefault();
      e.stopPropagation();
      let type = e.item.item.id;

      let selected_user_id = this.query.options[type + '_id'];

      let popup = spat.popup.open('popup-suggestion-users', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 8,
        offsetLeft: -20,
        position: 'bottom',
        opts: {
          label: `${e.item.item.label}をフィルター`,
          users: this.opts.users,
          selectedUsersIds: selected_user_id ? [selected_user_id] : [],
        },
      }).on('userselect', ({user}) => {

        this.toggleQueryValue(`${e.item.item.id}:${user.data.screen_name}`, e.item.item.toggle);

        popup.close();
      });
    };

    this.isEnabledUserFilter = (item) => {

      let value = this.query.options[item.id + "_id"];
      return value && value !== '-';
    };

    this.onKeydown = (e) => {
      e.preventUpdate = true;

      if (e.keyCode === 27) {
        e.currentTarget.blur();
      }
    };

    this.focus = () => {
      this.refs.query.focus();
    };

    this.clickCheckbox = (name) => {
      const $checkbox = this.root.querySelector(`[name="${name}"]`);
      if ($checkbox) {
        $checkbox.click();
      }
    };

    this.clickAssignedCheckbox = () => {
      this.clickCheckbox('assigned');
    };

    this.onClickProject = async (e) => {
      const popup = spat.popup.open('popup-suggestion-projects', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        opener: this.root,
        position: 'bottom',
      });
      const value = await popup.waitClose();

      requestAnimationFrame(() => {
        this.focus();
      });

      if (this.project) {
        this.removeQueryValue('project_id:' + this.project.id);
      }

      if (value) {

        if (value.type === 'all') {
          this.project = undefined;
        }
        else {

          this.project = value;
          this.addQueryValue('project_id:' + this.project.id);
          await value.fetch();
        }
      }
    };

    this.isEnabledCustomFilter = (item) => {
      let value = this.query.options[item.id];
      return value && value !== '-';
    };

    this.onClickCustomFilter = async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const item = e.item.item;
      const value = this.query.options[item.id];
      const res = await item.action({ value, nativeEvent: e });
      this.setQueryParam(e.item.item.id, res, e.item.item.toggle);
    };

    this.onClickCustomFilterArrowDown = async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const item = e.item.item;
      const value = this.query.options[item.id];
      const res = await item.actionArrowDown({ value, nativeEvent: e });
      this.setQueryParam(e.item.item.id, res, e.item.item.toggle);
    };

    this.onClickCustomCheckbox = async (e) => {
      e.stopPropagation();
      const item = e.item.item;
      const value = this.query.options[item.id];

      if (value) {
        this.removeQueryParam(e.item.item.id);
        this.updateQuery();
        return;
      }

      if (item.actionCheckbox) {
        const res = await item.actionCheckbox({ value, nativeEvent: e });
        this.setQueryParam(e.item.item.id, res, e.item.item.toggle);
      }
      else {

        this.onClickCustomFilter(e);
      }
    };

    this.onOpenSuggestions = async (e) => {
      const popup = spat.popup.open('popup-suggestion-filters', {
        element: e.currentTarget,
        align: { x: 'right'},
        offsetTop: 8,
        closeTarget: this.refs.query,
        opts: {
          value: this.refs.query.value,
        }
      });

      await popup.waitClose();
      if (popup.value) {
        this.setQueryValue(popup.value);
      }
    };
});